var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.5,5.1H7.8c-0.2,0-0.4,0.2-0.4,0.4c0,0,0,0,0,0v33.5H5.7c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4 h33.6c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.1-0.4-0.3-0.4h-1.5V5.5C37.8,5.3,37.7,5.1,37.5,5.1z M12.4,39.1V10.6h9.8v28.4H12.4z  M32.6,39.1h-9.7V10.6h9.7V39.1z M37.1,39.1h-3.8V10.2c0-0.2-0.2-0.4-0.4-0.4H12.1c-0.2,0-0.4,0.2-0.4,0.4l0,0v28.8H8.1V5.9h29V39.1 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.2,10.6h-9.8v28.4h9.8V10.6z M18.1,24.9c-0.1-0.8,0.5-1.5,1.3-1.6c0.8,0.1,1.5,0.8,1.4,1.6c0,0,0,0,0,0 c0,0.8-0.6,1.4-1.4,1.5C18.6,26.3,18,25.6,18.1,24.9C18.1,24.9,18.1,24.9,18.1,24.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.4,25.6c0.4-0.1,0.7-0.4,0.7-0.8c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0,0,0 C18.7,25.3,19,25.6,19.4,25.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.6,24c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7c0,0,0,0,0,0 c0.1-0.4-0.2-0.7-0.6-0.8C25.7,24.1,25.6,24,25.6,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.9,10.6v28.4h9.7V10.6H22.9z M25.6,26.4c-0.8-0.1-1.4-0.7-1.4-1.5c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4 c0,0,0,0,0,0C27,25.6,26.4,26.3,25.6,26.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.1,5.9v33.1h3.6V10.2c0-0.2,0.2-0.4,0.4-0.4l0,0h20.8c0.2,0,0.4,0.2,0.4,0.4v28.8h3.8V5.9H8.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M19.4,26.4c0.8-0.1,1.4-0.7,1.4-1.5c0.1-0.8-0.6-1.5-1.4-1.6c0,0,0,0,0,0c-0.8,0.1-1.4,0.8-1.3,1.6 C18,25.6,18.6,26.3,19.4,26.4C19.4,26.3,19.4,26.3,19.4,26.4z M18.7,24.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0 c0,0.4-0.3,0.7-0.7,0.8C19,25.6,18.7,25.3,18.7,24.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M25.6,23.2c-0.8,0.1-1.5,0.8-1.4,1.6c0,0,0,0,0,0c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4c0,0,0,0,0,0 C27.1,24,26.4,23.3,25.6,23.2C25.6,23.3,25.6,23.3,25.6,23.2z M25.6,25.6c-0.4-0.1-0.7-0.4-0.7-0.8c0-0.4,0.3-0.7,0.7-0.7 s0.7,0.3,0.7,0.7c0,0,0,0,0,0C26.3,25.3,26,25.6,25.6,25.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.7447ee59f528373ce9db54e138ffdc52.svg";
export { ForwardRef as ReactComponent };